import React from "react";

export default function SuccessPage() {
    return (
        <div style={{ textAlign: 'center', fontWeight: 600, fontSize: '36px', paddingTop: '20px' }}>Success, your update is complete</div>
    );
}